import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative grid grid-cols-6 gap-x-4" }
const _hoisted_2 = { class: "col-span-3" }
const _hoisted_3 = { class: "h-9.5 flex items-center" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_6 = { class: "text-xs text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiSelect = _resolveComponent("UiSelect")!
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_UiFormError = _resolveComponent("UiFormError")!
  const _component_PhoneMenuItemDialog = _resolveComponent("PhoneMenuItemDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_UiSelect, {
        disabled: _ctx.disabled,
        hiddenLabel: "",
        label: "Key",
        name: "key",
        placeholder: "--",
        inputId: `key_${_ctx.formData.id}`,
        options: _ctx.options,
        modelValue: _ctx.formData.key,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.key) = $event))
      }, null, 8, ["disabled", "inputId", "options", "modelValue"]),
      _createVNode(_component_UiInput, {
        class: "col-span-2",
        disabled: _ctx.disabled,
        label: "Voice",
        hiddenLabel: "",
        name: "voice",
        inputId: `command_${_ctx.formData.id}`,
        placeholder: "Command",
        modelValue: _ctx.formData.voice,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.voice) = $event))
      }, null, 8, ["disabled", "inputId", "modelValue"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            disabled: _ctx.disabled,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.edit && _ctx.edit(...args))),
            class: _normalizeClass([
						'inline-flex items-center',
						!_ctx.disabled
							? 'group hover:underline cursor-pointer'
							: 'cursor-default'
					])
          }, [
            (_ctx.formData.type === 3)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("Let the call through")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.selectedPhone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createTextVNode(_toDisplayString(_ctx.selectedPhone.friendlyName) + " ", 1),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.selectedPhone.phoneNumber), 1)
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.formData.destination), 1)
                      ], 64))
                ], 64)),
            _createVNode(_component_SvgIcon, {
              class: "ml-2 h-4 w-4 transition opacity-0 group-hover:opacity-100",
              name: "edit"
            })
          ], 10, _hoisted_4)
        ]),
        _createVNode(_component_UiFormError, {
          label: "Destination",
          name: "destination"
        })
      ]),
      _createVNode(_component_SvgIcon, {
        class: _normalizeClass([
				'transition opacity-50 h-5 w-5 absolute right-1 top-2',
				{
					'cursor-pointer hover:opacity-100':
						!_ctx.disabled,
					'cursor-not-allowed': _ctx.disabled
				}
			]),
        name: "close",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (!_ctx.disabled && _ctx.$emit('removeItem')))
      }, null, 8, ["class"])
    ]),
    _createVNode(_component_PhoneMenuItemDialog, {
      ref: "dialog",
      onUpdate: _ctx.onUpdate
    }, null, 8, ["onUpdate"])
  ], 64))
}